import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CommonUiModule } from '@bcl/common-ui';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonUiModule,
    IonicModule,
  ],
  declarations: [LoginComponent],
  exports: [],
  providers: [],
})
export class LoginModule {
  constructor() {}
}
